import { render, staticRenderFns } from "./DashboardNotes.vue?vue&type=template&id=e9399c4c"
import script from "./DashboardNotes.vue?vue&type=script&lang=js"
export * from "./DashboardNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports